module.exports = __webpack_public_path__ + "static/media/Visa.fb260dd2.svg";